import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { FromParam } from '../_helpers/alertsFilterParams';
import { AlertsDashboardAction } from '../alertsDashboard.action';

export const changeDashboardAlertsFromEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(AlertsDashboardAction.updateFrom),
  mergeMap((payload) => {
    return [
      payload
        ? RouterAction.addParam(FromParam.nameAndValue(payload.valueOf()))
        : RouterAction.removeParam(FromParam.name),
    ];
  }),
);
